module.exports = __webpack_public_path__ + "static/media/plastificirani-paneli.c5a68cec.png";